import { createContext } from "react";

const ProductGapSubFilter = createContext([]);

export default ProductGapSubFilter;
